/* eslint-disable */

import React, { Component } from 'react';

import { getVideo } from '../../fbApi/Videos';
import './CarouselPreviewList.css';

class CarouselPreviewList extends Component {
  state = {
    token: this.props.getFbToken(),
    videosUrl: []
  };

  getVideoUrl = async (asset, index) => {
    const videosUrl = this.state.videosUrl;
    const video = await getVideo(asset, this.state.token);
    const assetPreview = video && video.source ? video.source : '';

    videosUrl[index] = assetPreview;
    this.setState({ videosUrl });

    return assetPreview;
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.cards) {
      nextProps.cards.map(async (card, index) => {
        await this.getVideoUrl(card.video, index);
      });
    }
  }

  render() {
    if (this.props.cards) {
      return (
        <div className="cards-container-preview">
          {this.props.cards.map((card, index) => (
            <div>
              <div>
                <label>
                  <b>{card.cardName}</b>
                </label>
              </div>
              <div className="assets-container-preview">
                <div className="asset-container-preview">
                  <img
                    src={card.image_url}
                    className="card-asset-container-preview"
                  />
                </div>
                <div className="asset-container-preview">
                  {this.state.videosUrl[index] ? (
                    <video
                      width="100%"
                      controls
                      loop
                      autoPlay
                      className="card-asset-container-preview"
                    >
                      <source
                        src={this.state.videosUrl[index]}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      );
    }
    return null;
  }
}

export default CarouselPreviewList;



// WEBPACK FOOTER //
// ./src/screens/AdBlueprint/CarouselPreviewList.js